import { SearchQuery } from 'lib/models/searches/query';
import { SearchResult } from 'lib/models/searches/search-results';
import React from 'react';

export const BreakdownPopup: React.FC<{
  item: SearchResult;
  query: SearchQuery;
}> = ({ item, query }) => {
  // Variables
  const diagnosis = item.diagnosis;
  const symptomHits = item.symptomHits;
  const localizedHits = item.localizedHits;

  // Render sections

  return (
    <div className="page-searches-breakdown-popup">
      <h1>Matches for {diagnosis.name}</h1>
      <h3>
        Symptoms{' '}
        <span className="font-normal opacity-60">({item.symptomHits.length})</span>
      </h3>
      {symptomHits.map((hit, index) => (
        <pre key={index}>
          {hit.symptom.name}{' '}
          <span className="font-normal opacity-60">{hit.symptom.type.label}</span>
        </pre>
      ))}
      <h3>
        Localized findings{' '}
        <span className="font-normal opacity-60">({item.localizedHits.length})</span>
      </h3>
      {localizedHits.map((hit, index) => (
        <pre key={index}>
          {hit.localized.type.label}{' '}
          <span className="font-normal opacity-60">
            {hit.match.map((m) => m.attribute).join(', ')}
          </span>
        </pre>
      ))}
    </div>
  );
};
